import api from "../../api";
import { isValidEmail } from "../../../utils/validation";

export const updateProfileEmail = async (email: string) => {
  const normalizedEmail = email.trim();
  if (!isValidEmail(normalizedEmail)) {
    throw new Error("Informe um e-mail válido.");
  }

  await api.post("mobile/trocarEmail", { email: normalizedEmail });

  return normalizedEmail;
};

export const PROFILE_PHOTO_MAX_BYTES = 5 * 1024 * 1024;

export const PROFILE_PHOTO_ACCEPTED_TYPES = [
  "image/jpeg",
  "image/pjpeg",
  "image/png",
  "image/webp",
];

export const validateProfilePhoto = (file: File) => {
  if (!PROFILE_PHOTO_ACCEPTED_TYPES.includes(file.type)) {
    return "Formato não suportado. Envie uma imagem JPG, PNG ou WEBP.";
  }

  if (file.size > PROFILE_PHOTO_MAX_BYTES) {
    return "A imagem deve ter no máximo 5 MB.";
  }

  return null;
};

export const uploadProfilePhoto = async (file: File): Promise<string> => {
  const validationMessage = validateProfilePhoto(file);

  if (validationMessage) {
    throw new Error(validationMessage);
  }

  const payload = new FormData();
  payload.append("file", file);

  const response = await api.post<{ imgUsuario?: string }>(
    "mobile/foto-perfil",
    payload
  );

  const imgUsuario = response.data?.imgUsuario;

  if (typeof imgUsuario !== "string" || !imgUsuario) {
    throw new Error("A API não retornou a foto enviada.");
  }

  return imgUsuario;
};

export const removeProfilePhoto = async (): Promise<void> => {
  await api.delete("mobile/foto-perfil");
};
